export enum FORM_TYPE {
  IDEA = 297,
  ARTICLE = 298,
}
